import EventEmitter from "events"

export const cookiesKey = {
    accessToken: 'accessToken',
    refreshToken: 'refreshToken',
}

export const event = new EventEmitter()
export const eventKeys = {
    cookiesCleared: 'cookiesCleared'
}

export const MapsRestriction: google.maps.MapRestriction = {
    latLngBounds: {
        north: 85,
        south: -85,
        west: -180,
        east: 180
    }
}

export const DefaultCenter: google.maps.LatLngLiteral = { lat: 37.0902, lng: -95.7129 }